<template>
  <span>
    <span class="value">{{ number }}</span>
    <small class="percent">%</small>
  </span>
</template>

<script>
export default {
  name: 'AppPercent',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    integer: Boolean,
  },
  computed: {
    number() {
      if (null === this.value) {
        return 0
      }
      return this.integer ? parseInt(this.value) : this.value
    },
  },
}
</script>
